import X from '../x.js';

class XColor extends X {
  static get properties() {
    return {
      options: {
        type: Array
      },
      value: {
        type: String
      }
    };
  }

  constructor() {
    super();

    this.options = [];
    this.value = null;
  }

  render(target) {
    target.innerHTML = `
      <style>
        :host {
          display: flex;
        }

        .container {
          position: relative;
          margin-right: 1rem;
        }

        .container:last-child {
          margin-right: 0;
        }

        input {
          position: absolute;
          opacity: 0;
        }

        label {
          width: 2rem;
          height: 2rem;
          display: block;
          cursor: pointer;
        }

        label {
          width: 1.5rem;
          height: 1.5rem;
          border-radius: var(--checkbox-border-radius, 1.5rem);
          border: 2px solid transparent;
        }

        input:focus + label {
          border-color: grey;
        }

        input:checked + label {
          border-color: black;
        }
      </style>

      ${this.options
        .map(option => {
          return `
          <div class="container">
            <input
              type="radio"
              value="${option}"
              id="color-${option}"
              name="color"
            >
            <label
              for="color-${option}"
              style="background-color: ${option};"
            ></label>
          </div>
        `;
        })
        .join('')}
    `;
  }

  setup() {
    this.options.forEach(option => {
      const el = this.$[`color-${option}`];
      this.on(el, 'change', this.onChange);
    });

    if (!this.value) {
      this.value = this.options[0];
    }
  }

  update(target, triggers) {
    if (this.value && 'value' in triggers) {
      this.$[`color-${this.value}`].checked = true;
    }
  }

  onChange(event) {
    this.value = event.target.value;
  }
}

customElements.define('x-color', XColor);
